import {
  getProductTypeName,
  getOrderTypeName,
  ProductType,
  getStatusName,
  OrderPriceType,
  getTimeFrameName,
  TimeFrame
} from "../Order/Order";

const headers = [
  { header: "Id", key: "id" },
  { header: "Date", key: "date" },
  { header: "ModifiedDate", key: "modifiedDate" },
  { header: "Product", key: "product" },
  { header: "Side", key: "side" },
  { header: "Ticker", key: "symbol" },
  { header: "Quantity", key: "quantity" },
  { header: "Client account", key: "AccountName" },
  { header: "Holder", key: "HolderName" },
  { header: "Price", key: "customPrice" },
  { header: "Time Frame", key: "timeFrame" },
  { header: "Status", key: "status" },
  { header: "ExecId", key: "execId" },
  { header: "Quantity", key: "execQuantity" },
  { header: "DateTime", key: "execDate" },
  { header: "Price", key: "execPrice" },
  { header: "Broker", key: "execBroker" },
  { header: "Counterparty", key: "execCounterparty" },
];

const getEmptyRowOrder = () => {
  let row = {};

  headers.forEach(item => (row[item.key] = null));

  return row;
};

const getOrderValues = order => {
  const timeFrame = getOrderTimeFrame(order);
  let name = ' ';
  if (order.CurrentAccount !== undefined) {
    name = order.CurrentAccount.HolderName;
  }
  return {
    id: order.OrderId,
    date: order.OrderInitDate,
    modifiedDate: order.OrderModifiedDate,
    product: getProductTypeName(order.AssetClassForm),
    side: getOrderSide(order),
    symbol: order.AssetTicker,
    quantity: Number(parseFloat(order.OrderQuantity).toFixed(2)).toLocaleString('es-ES', {minimumFractionDigits: 2},{maximumFractionDigits:2}),
    AccountName:  order.CurrentAccount? order.CurrentAccount.AccountName:'',
    HolderName: name,
    customPrice: Number(parseFloat(getOrderPrice(order)).toFixed(2)).toLocaleString('es-ES', {minimumFractionDigits: 2},{maximumFractionDigits:2}),
    timeFrame: timeFrame.name,
    timeFrameDate: timeFrame.date,
    status: getStatusName(order.OrderStatus),
  };
};

const getExecutionValues = execution => {
  return {
    execId: execution.ExecutionId,
    execQuantity: Number(parseFloat(execution.ExecutionQuantity).toFixed(2)).toLocaleString('es-ES', {minimumFractionDigits: 2},{maximumFractionDigits:2}),
    execDate: execution.ExecutionDate,
    execPrice: Number(parseFloat(execution.ExecutionPrice).toFixed(2)).toLocaleString('es-ES', {minimumFractionDigits: 2},{maximumFractionDigits:2}),
    execBroker: execution.brokerName,
    execCounterparty: execution.counterpartyName
  };
};

const buildRows = orders => {
  let excelRows = [];
  let newOrders = [];

  //If orders.todo is undefined then we're probably in advisor and we don't need these fields.
  orders.todo ? newOrders = newOrders.concat(orders.todo, orders.working, orders.completed) : newOrders = orders; 
  
  newOrders.forEach(order => {
    let orderRows = [];

    const orderRow = getOrderValues(order);

    //Empty execs case
    orderRows.push(orderRow);

    order.Childs.forEach(child =>
      child.Executions.forEach((execution, index) => {
        let row = getEmptyRowOrder();

        if (index == 0) {
          orderRows.pop();

          row = {
            ...row,
            ...orderRow
          };
        }

        row = {
          ...row,
          ...getExecutionValues(execution)
        };

        orderRows.push(row);
      })
    );
    excelRows.push(...orderRows);
  });

  return excelRows;
};

const getOrderPrice = order => {
  let price;

  if (
    [ProductType.EQUITY, ProductType.OPTION, ProductType.FOREX].indexOf(
      order["AssetClassForm"]
    ) >= 0
  ) {
    if (order.OrderType == OrderPriceType.MARKET) {
      price = "";
    } else if (order.OrderType == OrderPriceType.STOPLIMIT) {
      price = `${order.OrderPrice} - ${order.OrderStopPrice}`;
    } else if (order.OrderType == OrderPriceType.STOP) {
      price = order.OrderStopPrice;
    } else {
      price = order.OrderPrice;
    }

    return `${price} ${getOrderTypeName(order.OrderType)}`;
  } else if (
    ProductType.MFUNDS != order["AssetClassForm"] &&
    order["OrderPrice"] != undefined
  ) {
    return order.OrderPrice;
  } else {
    return "";
  }
};

const getOrderTimeFrame = order => {
  if (
    [ProductType.EQUITY, ProductType.OPTION, ProductType.FOREX].indexOf(
      order["AssetClassForm"]
    ) >= 0
  ) {
    return {
      name: getTimeFrameName(order.OrderTimeInForce),
      date: order.OrderTimeInForce == TimeFrame.GTD ? order.OrderGTD : null
    };
  }

  return {};
};

const getOrderSide = order => {
  let side = order.OrderSide;

  if (order &&order["AssetClassForm"] == ProductType.EQUITY) {
    side += order.OrderOpenClose == "Open" ? "-O" : "-C";
  }

  return side;
};

export const getReportOrdersData = orders => {
  return {
    headers,
    rows: buildRows(orders)
  };
};
